<ng-container *transloco="let t">
  <div class="whats-new-panel">
    <p class="whats-new-subtitle">
      {{ t('whatsNew.subtitle', { portalName }) }}
    </p>
    <div
      class="whats-new-list"
      role="region"
      tabindex="0"
      [attr.aria-label]="t('whatsNew.subtitle', { portalName })">
      @for (feature of activeFeatures(); track feature.featureKey) {
        <article class="whats-new-item">
          <h3>{{ t(feature.title) }}</h3>
          <time [attr.datetime]="feature.publishedAt">
            {{ feature.publishedAt | date: 'mediumDate' }}
          </time>
          <p class="whats-new-description">{{ t(feature.description) }}</p>
          @if (feature.hasTour) {
            <div class="whats-new-item-actions">
              <button
                class="whats-new-cta"
                type="button"
                (click)="onCta(feature)">
                {{ t('whatsNew.learnMore') }}
              </button>
            </div>
          }
        </article>
      } @empty {
        <p class="whats-new-empty">{{ t('whatsNew.empty') }}</p>
      }
    </div>
    <footer class="whats-new-footer">
      <shared-button
        [label]="t('close')"
        [type]="sharedButtonType.Secondary"
        (clickEvent)="onClose()" />
    </footer>
  </div>
</ng-container>
